import { useState } from "react";
import styles from "./ContactsAdd.module.css";
import { caxios } from '../../config/config.js';
import { Input } from "antd"; // ✅ Ant Design Input 추가

const ContactsAdd = ({ onClose, handleContactsList }) => {

    const [Contacts, setContacts] = useState(
        { user_id: "", name: "", phone: "", email: "", type: "solo", job_code: "", rank_code: "" }
    );

    const handlechange = (e) => {
        setContacts(prev => ({ ...prev, [e.target.name]: e.target.value }))
    }

    const handleAdd = () => {
        const name = Contacts.name.trim();
        let phone = Contacts.phone.trim();
        let email = Contacts.email.trim()

        // 1 필수 입력 체크
        if (!name) {
            alert("이름을 입력해주세요.");
            return;
        }
        if (!phone) {
            alert("전화번호를 입력해주세요.");
            return;
        }
        if (!email) {
            alert("이메일을 입력해주세요.");
            return;
        }

        // 이름 체크
        const nameRegex = /^[가-힣a-zA-Z\s]{2,6}$/;
        // 번호 체크
        const phoneRegex = /^010-\d{4}-\d{4}$/;
        // 이메일 체크
        const emailRegex = /^[a-zA-Z0-9]+$/;

        if (!nameRegex.test(name)) {
            alert("이름에는 숫자나 특수문자를 포함할 수 없습니다 (최소 2글자 ~ 최대 6글자).");
            return;
        }

        if (!phoneRegex.test(phone)) {
            alert("전화번호 형식이 올바르지 않습니다. 예: 010-1234-5678");
            return;
        }

        if (!emailRegex.test(email)) {
            alert("이메일에는 특수문자를 포함할 수 없습니다. ");
            return;
        }

        const payload = { ...Contacts, phone: String(Contacts.phone) };

        caxios.post("/contacts", payload, { headers: { "Content-Type": "application/json" } })
            .then((res) => {
                setContacts(res.data);
                handleContactsList();
                onClose();
            })
            .catch((err) => {
                console.error("주소록 등록 오류:", err);
                if (err.response && err.response.data) {
                    alert(err.response.data);
                } else {
                    alert("주소록 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.");
                }
            });
    };

    const handleOut = () => {
        onClose();
    }

    return (
        <div className={styles.container}>
            <div className={styles.mainHeader} style={{ fontSize: "20px", textAlign: "center" }}>
                개인 주소록 추가
            </div>
            <hr />

            {/* ✅ 인풋들 모두 hr 아래에 */}
            <div className={styles.formContainer}>
                <div className={styles.formRow}>
                    <label>이름</label>
                    <Input
                        className={styles.inputField}
                        onChange={handlechange}
                        name="name"
                        value={Contacts.name}
                    />
                </div>

                <div className={styles.formRow}>
                    <label>전화번호</label>
                    <Input
                        className={styles.inputField}
                        onChange={handlechange}
                        name="phone"
                        value={Contacts.phone}
                    />
                </div>

                <div className={styles.formRow}>
                    <label>이메일</label>
                    <div className={styles.emailBox}>
                        <Input
                            className={styles.inputField}
                            onChange={handlechange}
                            name="email"
                            value={Contacts.email}
                        />
                        <span>@Infinity.com</span>
                    </div>
                </div>

                <div className={styles.formRow}>
                    <label>부서</label>
                    <Input
                        className={styles.inputField}
                        onChange={handlechange}
                        name="job_code"
                        value={Contacts.job_code}
                    />
                </div>

                <div className={styles.formRow} style={{marginBottom:"10px"}}>
                    <label>직급</label>
                    <Input
                        className={styles.inputField}
                        onChange={handlechange}
                        name="rank_code"
                        value={Contacts.rank_code}
                    />
                </div>
            </div>
            <hr />
            <div className={styles.buttonBox}>
                <button className={styles.btns} onClick={handleOut}>취소</button>
                <button className={styles.btns} onClick={handleAdd}>완료</button>
            </div>
        </div>
    );
}

export default ContactsAdd;
